module.exports = __webpack_public_path__ + "img/avatar_9.64403435.svg";